module.exports = __webpack_public_path__ + "img/institut-physimed.ce019a48.webp";